<template>
  <div class="nitrTask">
    <div class="wrapHeader">
      <el-form :inline="true" :model="params" class="demo-form-inline">
        <el-form-item label="仓房名称">
          <el-input v-model="params.wareName" placeholder="输入仓房名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='publicWrap'>
        <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
          <el-button type="primary" icon="el-icon-plus" class="commonBtn addTask" plain @click="addTask">添加任务</el-button>
          <div class="setMacView" :style="`height:${height-100}px;width:${width-60}px`">
            <el-table
              :data="taskData"
              style="width: 100%"
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              :max-height="height-149"
              border
            >
              <el-table-column type="index" width="60" align='center' label="序号" :index="indexMethod"></el-table-column>
              <el-table-column prop="taskName" label="方案名称" align="center" min-width='100'></el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              :hide-on-single-page='true'
              :pageSize='selectTask.pageSize'
              :current-page='selectTask.pageNum'
              @current-change='pageChange'
              class='setPosition'>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      params:{

      }
    }
  },
  created(){
    this.getList()
  },
  methods:{
    getList(){

    }
  }

}
</script>

<style lang="scss" scoped>
  .nitrTask{
    .addTask{
      left: 15px;
    }
  }
</style>

